<mat-dialog-content>
  <div *ngIf="isLoading" class="row">
    <div class="col-12 pt-5 text-center">
      <mat-spinner class="m-0 m-auto"></mat-spinner>
    </div>
  </div>

  <div *ngIf="!isLoading">
    <h2>{{ "CASES.editor-prefill.title" | translate }}</h2>

    <form [formGroup]="form" (submit)="submitForm(form)">
      <div class="mb-4">
        <!-- Affiliate -->
        <app-input type="select" formControlName="affiliate_id" appearance="outline"
                   [label]="'CASES.editor-prefill.form.affiliate_id' | translate" [searchable]="true"
                   [selectOptions]="affiliates" [selectLabel]="'name'" [selectValue]="'id'">
        </app-input>
        <!-- Legal Advisor -->
        <app-input type="select" formControlName="legal_advisor_id" appearance="outline"
                   [label]="'CASES.editor-prefill.form.legal_advisor_id' | translate" [searchable]="true"
                   [selectOptions]="allLegalAdvisors" [selectLabel]="['first_name', 'last_name']"
                   [selectValue]="'id'">
        </app-input>
        <ng-container *ngIf="authUser?.packager?.master">
          <!-- Verifier -->
          <app-input type="select" formControlName="verifier_id" appearance="outline"
                     [label]="'CASES.editor-prefill.form.verifier_id' | translate" [searchable]="true"
                     [selectOptions]="allVerifiers" [selectLabel]="['first_name', 'last_name']"
                     [selectValue]="'id'">
          </app-input>
        </ng-container>
        <!-- Submit -->
        <button mat-raised-button color="primary" type="submit">
          {{ "CASES.editor-prefill.form.submit" | translate }}
        </button>
      </div>
    </form>
  </div>
</mat-dialog-content>
